// extracted by mini-css-extract-plugin
export default {"moreIcon":"StaffTable_moreIcon__kQ7DZ","contactLink":"StaffTable_contactLink__WGNTk","ellipsis":"StaffTable_ellipsis__URF7D","roleTag":"StaffTable_roleTag__oladF"};